import { useEffect, useState } from "react";
import { categories } from "@/mocks/media";

export default function MediaNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { key: "hot", label: "吃瓜热榜", href: "#hot" },
    ...categories.map((c) => ({ key: c.key, label: c.name, href: `#${c.key}` })),
    { key: "deep", label: "深度专题", href: "#deep" },
    { key: "about", label: "关于51影院", href: "#about" },
  ];

  return (
    <header className="sticky top-0 z-50 bg-background-50/90 backdrop-blur-md border-b border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <nav className="flex items-center justify-between h-16">
          <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
            <span className="w-9 h-9 rounded-lg bg-primary-600 flex items-center justify-center text-background-50 text-lg">
              <i className="ri-clapperboard-fill"></i>
            </span>
            <span className="font-heading font-bold text-xl tracking-wide text-foreground-900">
              51<span className="text-primary-600">影院</span>
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-1">
            {links.map((l) => (
              <a
                key={l.key}
                href={l.href}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 font-medium whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href="#contact"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 whitespace-nowrap"
            >
              <i className="ri-camera-lens-line text-base w-4 h-4 flex items-center justify-center"></i>
              我要爆料
            </a>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden w-10 h-10 rounded-md flex items-center justify-center text-foreground-700 hover:bg-background-100"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
          </button>
        </nav>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.key}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 rounded-md"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap"
            >
              <i className="ri-camera-lens-line"></i> 我要爆料
            </a>
          </div>
        </div>
      )}
    </header>
  );
}